import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { formatDate } from '@angular/common';
import { AttributeValidationError } from '../../section-instance/attribute-rows/attribute-number-edit-row/attribute-number-edit-row.component';

export function getStaticDateError(value: string | null, isRequired: boolean): AttributeValidationError | null {
  return !value && isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
}

@Component({
  selector: 'lib-static-date-edit-row',
  standalone: false,
  templateUrl: './static-date-edit-row.component.html',
  styleUrls: ['./static-date-edit-row.component.scss'],
})
export class StaticDateEditRowComponent implements OnInit {
  @Input() label: string = '';
  @Input() originalValue: string | null | undefined;
  @Input() value: string | null | undefined;
  @Input() isRequired: boolean = false;
  @Input() includeTime: boolean = false;
  @Output() valueChange = new EventEmitter<string | null>();
  inputValue: string = '';
  error: AttributeValidationError | null = null;

  ngOnInit(): void {
    const date = (this.value === undefined ? this.originalValue : this.value) ?? null;
    this.inputValue = date ? formatDate(date, this.includeTime ? "yyyy-MM-dd'T'HH:mm" : 'yyyy-MM-dd', 'en-US') : '';
    this.validate(date);
  }

  onValueChange(value: string) {
    const newValue = value ? (this.includeTime ? `${value}:00` : `${value}T00:00:00`) : null;
    this.valueChange.emit(newValue);
    this.validate(newValue);
  }

  private validate(value: string | null) {
    const isUnchanged =
      value !== null && !!this.originalValue && new Date(value).getTime() === new Date(this.originalValue).getTime();
    this.error = isUnchanged ? null : getStaticDateError(value, this.isRequired);
  }
}
